import { z } from 'zod';
/**
 * The six error codes from the Interface Contract. Every API in this repository
 * uses this shape; nothing invents a seventh code.
 */
export const ErrorCode = z.enum([
    'unauthenticated', // 401 — missing, malformed or expired token
    'forbidden', // 403 — scope missing, or the entitlements check said no
    'not_found', // 404 — absent, or present but the caller may not know
    'conflict', // 409 — state does not permit it
    'validation_failed', // 422 — the body is wrong
    'unavailable', // 503 — a hard dependency is down. Never an allow
]);
export const FieldProblem = z.object({
    path: z.string(),
    problem: z.string(),
    detail: z.string().optional(),
});
export const ApiError = z.object({
    error: z.object({
        code: ErrorCode,
        message: z.string(),
        fields: z.array(FieldProblem).optional(),
    }),
});
export const HTTP_STATUS_FOR = {
    unauthenticated: 401,
    forbidden: 403,
    not_found: 404,
    conflict: 409,
    validation_failed: 422,
    unavailable: 503,
};
//# sourceMappingURL=errors.js.map